// 角色类型常量(roleType),与后端 getAccountRoleType 接口返回值一一对应。
// 集中定义,消除全项目散落的魔法数字(1/2/3/4/10005 等)。
export const ROLE = {
  // —— 现有角色(逻辑不变)——
  ADMIN: 1,        // 超管 / 平台
  SECOND: 2,       // 二级账号 / 渠道
  CHANNEL_SUB: 3,  // 渠道子账号
  DOWNSTREAM: 4,   // 下游渠道

  // —— 新增角色(10000 起,按 各职位后台功能权限配置.xlsx 列序)——
  PRODUCT: 10000,  // 产品部
  FINANCE: 10001,  // 财务部
  PDK_LEAD: 10002, PDK_BIZ: 10003, PDK_OPS: 10004,       // PDK 部门负责人/商务/运营
  CM_LEAD: 10005,  CM_BIZ: 10006,  CM_OPS: 10007,        // 渠道项目 部门负责人/商务/运营
  M2S_LEAD: 10008, M2S_BIZ: 10009, M2S_OPS: 10010,       // M2S 部门负责人/商务/运营
  SUP_LEAD: 10011, SUP_BIZ: 10012, SUP_OPS: 10013,       // SUP 部门负责人/商务/运营
  AAU_LEAD: 10014, AAU_BIZ: 10015, AAU_OPS: 10016,       // AAU 部门负责人/商务/运营
  ROB_LEAD: 10017, ROB_BIZ: 10018, ROB_OPS: 10019,       // ROB 部门负责人/商务/运营
  TRE_LEAD: 10020, TRE_BIZ: 10021, TRE_OPS: 10022,       // TRE 部门负责人/商务/运营
}

// 「标准 12 项」角色组(渠道3 + M2S负责人/商务 + SUP3 + TRE3,共 11 个)
export const FULL_A = [
  ROLE.CM_LEAD, ROLE.CM_BIZ, ROLE.CM_OPS,
  ROLE.M2S_LEAD, ROLE.M2S_BIZ,
  ROLE.SUP_LEAD, ROLE.SUP_BIZ, ROLE.SUP_OPS,
  ROLE.TRE_LEAD, ROLE.TRE_BIZ, ROLE.TRE_OPS,
]

// AAU 商务/运营(6 项组)
export const AAU_BIZ_OPS = [ROLE.AAU_BIZ, ROLE.AAU_OPS]

// 报单汇总账号特例
export const XIAOMI = '2576247038583552'
